import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type PhoneHangUpIconProps = IconProps

const PhoneHangUpIcon = forwardRef<SVGSVGElement, PhoneHangUpIconProps>(
  (props: PhoneHangUpIconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5.475 12.863a18.998 18.998 0 0 1-2.304-5.102c-.16-.564-.24-.846-.241-1.26a3.377 3.377 0 0 1 .384-1.478c.202-.36.467-.624.997-1.154l.157-.158c.532-.531.798-.797 1.083-.941a2 2 0 0 1 1.805 0c.286.144.551.41 1.083.941l.195.195c.35.35.524.525.638.7a2 2 0 0 1 0 2.18c-.114.177-.289.351-.638.701a2.02 2.02 0 0 0-.22.238 1.05 1.05 0 0 0-.147.862c.023.08.053.142.113.266.121.252.25.5.386.747m2.416 3.218.045.045a14.605 14.605 0 0 0 4.01 2.846c.124.06.187.09.265.113.28.082.625.023.862-.147.067-.048.124-.105.239-.22.35-.349.524-.524.7-.638a2 2 0 0 1 2.18 0c.176.114.35.29.7.639l.195.195c.532.531.797.797.942 1.082a2 2 0 0 1 0 1.806c-.145.285-.41.55-.942 1.082l-.157.158c-.53.53-.795.794-1.155.997-.4.224-1.02.385-1.478.384-.413-.001-.695-.081-1.26-.241a19.038 19.038 0 0 1-8.283-4.874L8 16M21 3 3 21"
        fill="none"
      ></path>
    </Icon>
  ),
)

PhoneHangUpIcon.displayName = 'PhoneHangUpIcon'
PhoneHangUpIcon.defaultProps = iconDefaultProps

export type { PhoneHangUpIconProps }
export { PhoneHangUpIcon }
